/**
 * Accessibility helpers (WCAG 1.4.13): make hover-triggered header content
 * dismissible with the Escape key without moving the pointer or focus.
 */
(function () {
  function dismissHoverMenus() {
    var dismissed = false;
    document.querySelectorAll('.overflow-menu').forEach(function (om) {
      var expanded = om.querySelector('[aria-expanded="true"]');
      if (expanded) {
        om.setAttribute('data-esc-dismissed', '');
        var item = expanded.closest('li') || expanded;
        [item, expanded].forEach(function (el) {
          el.dispatchEvent(new PointerEvent('pointerleave', { bubbles: true }));
        });
        if (document.activeElement === expanded) expanded.blur();
        dismissed = true;
      }
    });
    return dismissed;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') dismissHoverMenus();
  });

  /* Re-arm: allow the menu to open again when the pointer re-enters it */
  document.addEventListener(
    'pointerover',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('li[slot="more"], .overflow-menu')) {
        document.querySelectorAll('.overflow-menu[data-esc-dismissed]').forEach(function (om) {
          om.removeAttribute('data-esc-dismissed');
        });
      }
    },
    true
  );
})();
